import { useAddAccount } from '@pages/addAccount/useAddAccount';
import { useMemo } from 'react';

export const useFixedFields = (account: ReturnType<typeof useAddAccount>) => {
  return useMemo(() => {
    const isTransportadora = account.selectedRole === 'transportadora';
    const isPosto = account.selectedRole === 'posto';
    const isProcon = account.selectedRole === 'procon';
    const isRevenda = account.selectedRole === 'revenda';
    const isAdvogado = account.selectedRole === 'advogado' || account.selectedRole === 'juiz';
    const isPessoaFisica = account.tipoContas === 'pessoa_fisica';
    const isPessoaJuridica = account.tipoContas === 'pessoa_juridica';
    const fields = [];

    if ((isPessoaFisica || isPosto || isAdvogado) && !isProcon && !isRevenda && !isTransportadora) {
      fields.push({
        key: 'name',
        title: 'Nome completo',
        type: 'text',
        value: account.newUser.name,
        onChange: (value: string) => {
          const capitalizeWords = (str: string) =>
            str
              .toLocaleLowerCase('pt-BR')
              .split(' ')
              .map(word => word.charAt(0).toLocaleUpperCase('pt-BR') + word.slice(1))
              .join(' ');

          account.setNewUser({ ...account.newUser, name: capitalizeWords(value) });
        },
      });
    }

    if ((isPessoaFisica || isAdvogado) && !isPosto && !isProcon && !isRevenda && !isTransportadora) {
      fields.push({
        key: 'cpf_3',
        title: 'CPF',
        type: 'text',
        value: account.newUser.cpf_3,
        onChange: (value: string) => account.handleInputChange('cpf_3', value),
        onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (!/^[0-9.-]$/.test(e.key)) {
            e.preventDefault();
          }
        },
        error: account.cpfError,
        existUser: account.existUser,
      });
    }

    if ((isPessoaJuridica || isTransportadora || isPosto || isProcon || isRevenda) && !isAdvogado) {
      fields.push({
        key: 'cnpj_regex',
        title: 'CNPJ',
        type: 'text',
        value: account.newUser.cnpj_regex,
        onChange: (value: string) => account.handleInputChange('cnpj_regex', value),
      });
    }

    fields.push(
      {
        key: 'phone',
        title: 'Telefone',
        type: 'text',
        value: account.newUser.phone,
        onChange: (value: string) => account.handleInputChange('phone', value),
      },
      {
        key: 'email',
        title: 'E-mail',
        type: 'email',
        value: account.newUser.email,
        onChange: (value: string) => account.handleInputChange('email', value),
        error: account.emailError,
        existUser: account.existUserEmail,
      }
    );

    return fields;
  }, [
    account.newUser.name,
    account.newUser.email,
    account.newUser.phone,
    account.newUser.cpf_3,
    account.newUser.cnpj_regex,
    account.cpfError,
    account.emailError,
    account.existUser,
    account.existUserEmail,
    account.handleInputChange,
    account.selectedRole,
    account.tipoContas
  ]);
};